import fallbackSource from '../assets/video-unavailable.mp4?inline';

// Bundle the small clip with the player so it also works without a content copy.
export function installVideoFallback(player) {
	let attempted = false;

	player.on('error', () => {
		const error = player.error();
		if (attempted || !error || ![2, 3, 4].includes(error.code) || player.ads?.inAdBreak?.()) {
			return;
		}

		// Never retry the fallback itself if playback is unavailable in this browser.
		attempted = true;
		player.error(null);
		player.poster('');
		player.muted(true);
		player.src({ src: fallbackSource, type: 'video/mp4' });
		player.play()?.catch(() => {
			// Browser autoplay policy can still require the reader to press play.
		});
	});
}
